import { withHTMLComponent } from '@updater-legacy/components/custom-element';
import styles from './index.css';

const html = '<i></i>';

export default class Icon extends withHTMLComponent(styles, html)() {
  static observedAttributes = ['name'];
  static reflectedAttributes = ['name'];

  constructor() {
    super();
    this._icon = this.shadowRoot.querySelector('i');
  }

  updated({ name }) {
    this._icon.style[
      'background-image'
    ] = `url('//d30c45h9cuv4p4.cloudfront.net/ico-${name}-large.svg')`;
  }
}

customElements.define('upd-icon', Icon);
